import { render, staticRenderFns } from "./DoctorsFilter.vue?vue&type=template&id=2d9ddec9&scoped=true&"
import script from "./DoctorsFilter.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorsFilter.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorsFilter.vue?vue&type=style&index=0&id=2d9ddec9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9ddec9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d9ddec9')) {
      api.createRecord('2d9ddec9', component.options)
    } else {
      api.reload('2d9ddec9', component.options)
    }
    module.hot.accept("./DoctorsFilter.vue?vue&type=template&id=2d9ddec9&scoped=true&", function () {
      api.rerender('2d9ddec9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorsFilter.vue"
export default component.exports